
<div class="flex flex-column h-full" style="max-height: 550px;">

<div class="flex flex-column pb-0 w-full border-bottom-1 bg-white surface-border "
style="position: sticky; top: -2px; z-index: 1;"
>
    <p class="m-0">Choose your departure airports, starting with the largest international one nearby for the best deals. Premium+ members can select up to 4. <span *ngIf="!user?.isPremiumPlus" class="underline cursor-pointer" (click)="goToUpgrade()">Learn more.</span></p>
    <div [id]="SEARCH_CONTAINER_ID" class="search-container relative w-full" (click)="onSearchClick()">
        <search-select
            #searchBox
            placeholder="Search Airports"
            [currentCount]="airports.length"
            [maxCount]="maxAirportCount"
            [existingIds]="airports"
            [resultCap]="4"
            [searchFn]="searchAirports"
            [idKey]="'id'"
            itemLabelSingular="airport"
            [showUpgradeModalOnLimit]="this.user?.isFree"
            [showDealFrequency]="true"
            (added)="addAirport($event)"
            (limitReached)="openUpgradeModal()">
        </search-select>

        <!-- Recommended Airports Dropdown -->
        <ul *ngIf="showRecommendedAirportDropdown" class="dropdown-list absolute left-0 right-0" style="top: 100%;">
            <div class="bg-white" style="padding: 4px 15px 4px 15px;">
                <span class="text-sm" style="color: #666; letter-spacing: 0.5px;">Nearby Recommendations</span>
            </div>
            <li *ngFor="let airport of recommendedAirports" [class.disabled]="isRecommendedAirportDisabled(airport)"
                (click)="!isRecommendedAirportDisabled(airport) && selectRecommendedAirport(airport, $event)">
                <div class="flex flex-column">
                    <div class="dropdown-item">
                        <img src="/assets/images/signup/AirportSearchDropdownLogo.webp" alt="Icon" class="airport-icon" />
                        <div class="dropdown-details">
                            <span class="airport-city">{{ airport.cityName }}</span>
                            <span class="airport-country">{{ airport.name }} ({{ airport.code }})</span>
                        </div>
                    </div>
                    <div style="padding-left: 30px" class="pt-1">
                        <p-tag *ngIf="airport.dealFrequency" [value]="(airport.dealFrequency | titlecase) + ' deal frequency'"
                            [styleClass]="'text-xs ' + airport.dealFrequencyClass">
                            <i class="ph-fill ph-chart-bar mr-1"></i>
                        </p-tag>
                    </div>
                </div>
            </li>
        </ul>
    </div>



</div>

<!-- Display Dream Destination cards here -->
<div class="overflow-auto" style="flex: 1; min-height: 0;">
 <div class="grid pt-4 mx-0">
    <div class="col-6" *ngFor="let airport of airports; trackBy: trackByAirportId" (mouseenter)="hoveredAirportId = airport.id"
         (mouseleave)="hoveredAirportId = null">
        <div class="relative">
            <div class="w-full" style="position: relative; padding-top: 100%; border-radius: var(--border-radius); overflow: hidden;">
                <img
                    [src]="airport.city.images[0].urlOriginal || '/assets/images/DFC-logo.webp'"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"
                />
              </div>
            <p-tag
                severity="success"
                [rounded]="true"
                styleClass="absolute top-0 right-0 mt-3 mr-3"
                [style]="{ width: '22.75px', height: '22.75px' }"
                (click)="removeAirport(airport)"
            >
                <i class="cursor-pointer ph ph-x text-black text-lg"

                ></i>
            </p-tag>


        </div>
        <div class="flex flex-column gap-2 mt-2">
            <h6 class="m-0">{{airport.cityName}}</h6>
            <h6 class="m-0 font-normal white-space-nowrap overflow-hidden text-overflow-ellipsis">{{airport.name}} ({{airport.code}})</h6>
            <div class="inline-flex align-items-center gap-1 font-semibold align-self-start"
                 [class.cursor-pointer]="airport.rank !== PRIMARY_RANK"
                 [style.color]="airport.rank === PRIMARY_RANK ? 'var(--primary-color)' : '#9e9e9e'"
                 (click)="airport.rank !== PRIMARY_RANK && setPrimary(airport)">
                <i [ngClass]="airport.rank === PRIMARY_RANK ? 'ph-fill ph-star' : 'ph ph-star'"></i>
                <span class="text-sm">{{ airport.rank === PRIMARY_RANK ? 'Primary airport' : 'Set as primary' }}</span>
            </div>
        </div>
    </div>
    <div class="col-6 cursor-pointer" *ngIf="airports.length < maxAirportCount || user?.isFree" (click)="handleAddAirportClick()">
        <div class="relative">
            <div
            class="w-full surface-200 flex justify-content-center align-items-center relative"
            style="
              aspect-ratio: 1;
              border-radius: var(--border-radius);
              overflow: hidden;
            "
          >
          <i class="ph ph-map-pin text-8xl text-white"></i>
              </div>
        </div>
        <div class="flex flex-column gap-2 mt-2">
            <h6 class="m-0">Add new Airport</h6>
        </div>
    </div>

 </div>
</div>

</div>

